(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("JsimpleBot", [], factory);
	else if(typeof exports === 'object')
		exports["JsimpleBot"] = factory();
	else
		root["JsimpleBot"] = factory();
})(this, () => {
return 